/**
 * Case-insensitive "contains" filter shared by all overview search boxes.
 *
 * Keeps every item for which at least one of its searchable values contains the
 * (trimmed of case) search term. An empty search term returns the list unchanged.
 *
 * @param items the list to filter
 * @param filterStr the raw search term entered by the user
 * @param getSearchableValues extracts the strings to match against for a single item;
 *        `null`/`undefined` values are ignored so callers don't need to guard them
 */
export const filterBySearchTerm = <T>(
  items: T[],
  filterStr: string,
  getSearchableValues: (item: T) => Array<string | null | undefined>
): T[] => {
  if (filterStr === '') {
    return items;
  }

  const searchTerm = filterStr.toLowerCase();

  return items.filter((item) => {
    const searchableValues = getSearchableValues(item);
    return searchableValues.some((value) => value?.toLowerCase().includes(searchTerm));
  });
};
